<template>
    <div class="select-usuario">
        <h5 class="title">{{ $t('vincular-colaborador') }}</h5>

        <div>
            <b-checkbox
                class="check-box"
                @input="selectAll"
                :indeterminate="itensSelectedCount != list.length && itensSelectedCount > 0"
                v-model="isAllSelected"
            >
                {{ $t('selecionar-todos') }}
            </b-checkbox>
        </div>

        <div class="list">
            <SearchList
                v-model="filtereditems"
                label="nome"
                height="300"
                :checkable="true"
                :onSearch="filtrar"
                :onCheck="select"
                :placeholder="$t('busca')"
            />
        </div>
    </div>
</template>
<script>
import SearchList from '@/components/shared/SearchList.vue';

export default {
    props: {
        list: {
            type: Array,
            default: () => [],
        },
    },
    components: {
        SearchList,
    },
    data() {
        return {
            filtereditems: [],
            dias: [],
            service: null,
            main: this.$parent.$parent,
            mirror: '',
            itensSelectedCount: 0,
            isAllSelected: false,
        };
    },
    created() {
        for (let index in this.list) {
            if (this.list[index].check) {
                this.itensSelectedCount++;
            }
        }
        this.isAllSelected = this.itensSelectedCount == this.list.length;
    },
    mounted() {
        this.filtereditems = [...this.list];
    },
    methods: {
        filtrar(searchQuery) {
            this.filtereditems = this.list.filter((i) =>
                new RegExp(searchQuery.toLocaleLowerCase(), 'gi').test(i.nome.toLocaleLowerCase())
            );
        },
        select(v) {
            if (v.check) {
                this.itensSelectedCount++;
            } else {
                this.itensSelectedCount--;
            }
            this.isAllSelected =
                this.itensSelectedCount == this.list.length && this.itensSelectedCount > 0;
        },
        selectAll() {
            let selectedAll = this.itensSelectedCount == this.list.length;

            this.itensSelectedCount = selectedAll ? 0 : this.list.length;

            for (let index in this.list) {
                let item = this.list[index];
                item.check = !selectedAll;
            }

            this.isAllSelected = !selectedAll;
        },
    },
};
</script>
<style lang="scss" scoped>
.select-usuario {
    width: 100%;
    .list {
        margin-top: 10px;
        flex: 1 1 auto;
        height: 100%;
    }
    h5.title {
        flex: 0 0 auto;
        width: 100%;
        font-size: 16px;
        margin-bottom: 8px;
    }
}

.form-buttons {
    position: absolute;
    top: 20px;
    right: 20px;
    display: flex;
    justify-content: flex-end;
}

.form-buttons .save-btn,
.form-buttons .delete-btn {
    color: $sovis-white;
    font-size: 12px;
    text-align: center;
    padding: 15px 40px;
    border: none;
    border-radius: 6px;
    font-weight: 600;
    margin-left: 20px;
    @include gradient-button();
}

.form-buttons .delete-btn {
    right: 225px;
    color: $darker-gray-color;
    @include exclude-button();
}

.list {
    margin-top: 30px;
}
</style>
